module.exports = __webpack_public_path__ + "static/media/Fabrication CAM Duct.617f9ba3.png";